<template>
 <v-container :class="['mx-auto']" style="max-width: 1340px">
  <TestiCliente/>   
 </v-container>
  
</template>

<script>
import TestiCliente from "../components/TestimoniosCliente"
export default {
components:{
    TestiCliente
}
}
</script>
